<template>
  <div>
    <TreatmentPlanRequest
      v-if="!showSpinner"
      :selectedTpr="selectedTpr"
      :surgicalCase="surgicalCase"
      :key="selectedTprId"
      @cloned="handleClone"
    />
    <b-spinner
      variant="warning"
      class="m-5"
      style="width: 3rem; height: 3rem"
      v-if="this.showSpinner"
    ></b-spinner>
  </div>
</template>

<script>
import TreatmentPlanRequest from "@/components/TreatmentPlanRequest.vue";
export default {
  data() {
    return { showSpinner: true, selectedTpr: null, surgicalCase: null };
  },
  async created() {
    this.showSpinner = true;
    const tprId = this.$route.query.id;
    const caseId = tprId.substring(0, tprId.lastIndexOf("-"));

    const tprResponse =
      await this.$treatmentPlanRequestsApi.treatmentplanrequestsGet({
        externalReference: tprId,
        includeAcknowledgedRequests: true,
      });
    this.selectedTpr = tprResponse.content[0];
    this.surgicalCase = await this.$surgicalCaseApi.surgicalcasesIdGet(caseId);
    this.showSpinner = false;
  },
  components: { TreatmentPlanRequest },
  computed: {
    selectedTprId() {
      return this.selectedTpr?.metadata?.requestId;
    },
  },
  methods: {
    async handleClone(newRequestId) {
      const response =
        await this.$treatmentPlanRequestsApi.treatmentplanrequestsIdGet(
          newRequestId
        );
      this.selectedTpr = response;
    },
  },
};
</script>

<style>
</style>